export default "__VITE_ASSET__Ciu3GLU1__"